import { render, staticRenderFns } from "./componentsPanel.vue?vue&type=template&id=377b9fae&scoped=true&"
import script from "./componentsPanel.vue?vue&type=script&lang=js&"
export * from "./componentsPanel.vue?vue&type=script&lang=js&"
import style0 from "./componentsPanel.vue?vue&type=style&index=0&id=377b9fae&scoped=true&lang=less&"
import style1 from "./componentsPanel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b9fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377b9fae')) {
      api.createRecord('377b9fae', component.options)
    } else {
      api.reload('377b9fae', component.options)
    }
    module.hot.accept("./componentsPanel.vue?vue&type=template&id=377b9fae&scoped=true&", function () {
      api.rerender('377b9fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentsPanel.vue"
export default component.exports